import React, { useContext, useEffect, useRef } from 'react';
import './sidebar.css';
import { useLocation, useNavigate, NavLink } from 'react-router-dom';
import clanderIcon from "../../Assets/sidenav_icons/Group 48099172.png";
import patientProfile from "../../Assets/sidenav_icons/Group 48099173.png";
import chartIcon from "../../Assets/sidenav_icons/solar_chart-bold.png";
import carbon_plan from "../../Assets/sidenav_icons/carbon_plan.png";
import userSetting from "../../Assets/sidenav_icons/ic_baseline-manage-accounts.png";
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { GET_READ_WAITING_REQUEST_NOTIFICATION, userProfileURL } from '../../repository/common';
import useReduxStore from '../../hooks/useReduxStore';
import notesActive from '../../Assets/sidenav_icons/notesActive.png';
import notesInActive from '../../Assets/sidenav_icons/notesInactive.png';
import treatmentActive from '../../Assets/sidenav_icons/treatmentActive.png';
import toothActive from '../../Assets/sidenav_icons/toothActive.png';
import userActive from '../../Assets/sidenav_icons/userActive.png';
import calenderActive from '../../Assets/sidenav_icons/calenderActive.png';
import userProfileActive from '../../Assets/sidenav_icons/userProfileActive.png';
import superBillActive from '../../Assets/sidenav_icons/superBillActive.png';
import superBillInActive from '../../Assets/sidenav_icons/superBillInActive.png';

import { NotificationsState } from '../../App';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigateRef = useRef(navigate);

  const { selector: user } = useReduxStore("auth");
  const { selector: PatientData } = useReduxStore("PatientData");
  const isPatient = Boolean(PatientData?.id);
  const { setBudgeNotification } = useContext(NotificationsState);

  const isMiniWindow = !!window.opener && window.name === "appointmentScheduler";

  // keep latest navigate in ref
  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);

  // notifications
  const getBudgeNotification = async () => {
    try {
      const payload = { userId: user?.user_id };
      const response = await GET_READ_WAITING_REQUEST_NOTIFICATION(payload);
      setBudgeNotification({
        waitingList: !response?.data?.waitingList ? 1 : 0,
        requrestAppointment: !response?.data?.requestAppointment ? 1 : 0
      });
    } catch (error) {
      console.error("Failed to fetch notifications", error);
    }
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'appointment_updated' && event.newValue === 'true') {
        getBudgeNotification();
        localStorage.setItem('appointment_updated', 'false');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [user]);

  useEffect(() => {
    if (location.pathname === "/appointment_scheduler") {
      getBudgeNotification();
    }
  }, [location.pathname]);

  // handle nav from popup or main
  const handleMainTabNavigate = (e, path) => {
    if (isMiniWindow) {
      e.preventDefault();
      try {
        window.opener.postMessage({ type: "NAVIGATE_TAB", path }, window.location.origin);
        window.opener.focus();

        // ⏳ Fallback: If focus fails silently, prompt the user
        setTimeout(() => {
          if (!document.hasFocus()) {
            alert("Please switch to the main tab manually if it did not come to focus.");
          }
        }, 1000);

      } catch (err) {
        console.error("Failed to switch focus to main tab", err);
      }
    } else {
      navigate(path); // Normal React navigation in main window
    }
  };

  // message listener
  useEffect(() => {
    if (isMiniWindow) return;

    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === "NAVIGATE_TAB" && event.data.path) {
        // guaranteed navigation
        if (location.pathname === event.data.path) {
          window.location.reload();

        } else {
          window.location.assign(event.data.path);
          console.log("Main window received NAVIGATE_TAB 3333333333:", event.data.path);
        }

        window.focus();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [location.pathname]);

  return (
    <div className="sidebar-content">
      <div className="sidebar-menu">

        {/* Appointment Scheduler Icon (always opens or focuses mini window) */}
        <div className="navlink">
          <Tooltip title="Appointment Scheduler">
            {/* {isPatient ? ( */}
            <NavLink
              to="/appointment_scheduler"
              end
              className={({ isActive }) => (isActive ? 'navlink-active' : 'navlink-inactive')}
            >
              {({ isActive }) => {
                const isMiniWindow = window.opener && window.name === 'appointmentScheduler';
                const active =
                  (isMiniWindow && window.location.pathname === '/appointment_scheduler') ||
                  (!isMiniWindow && isActive);

                return (
                  <img
                    alt="Appointment Scheduler"
                    src={active ? calenderActive : clanderIcon}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();

                      // Don't open again if already in mini window
                      if (isMiniWindow) return;

                      // Reuse same mini window with fixed size, position, and no full-screen
                      const windowFeatures = "width=1500,height=1000,resizable=no,scrollbars=yes";

                      // Check if the mini window is already open
                      let existingWindow = window.open(
                        "/appointment_scheduler",
                        "appointmentScheduler", // Same window name to reuse
                        windowFeatures
                      );

                      if (existingWindow) {
                        // Focus the mini window if it's already open
                        existingWindow.focus();
                      } else {
                        // If the window didn't open, log or handle the error here
                        console.error("Failed to open mini window.");
                      }
                    }}
                  />
                );
              }}
            </NavLink>

            {/* ) : (
              <img alt="Appointment Scheduler" src={clanderIcon} />
            )} */}
          </Tooltip>
        </div>

        {/* Patient Management */}
        <div className="navlink">
          <Tooltip title="Patient Management">
            {isPatient ? (
              <NavLink
                to="/patient-management"
                end
                className={({ isActive }) => isActive ? 'navlink-active' : 'navlink-inactive'}
              >
                {({ isActive }) => (
                  <img
                    alt="Patient Management"
                    src={isActive ? userProfileActive : patientProfile}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMainTabNavigate(e, "/patient-management")}
                  />
                )}
              </NavLink>
            ) : (
              <img alt="Patient Management" src={patientProfile} />
            )}
          </Tooltip>
        </div>

        {/* Charting */}
        <div className='navlink'>
          <Tooltip title="Charting">
            {isPatient ? (
              <NavLink
                to="/charting"
                end
                className={({ isActive }) => isActive ? 'navlink-active' : 'navlink-inactive'}
              >
                {({ isActive }) => (
                  <img
                    alt="Charting"
                    src={isActive ? toothActive : chartIcon}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMainTabNavigate(e, "/charting")}
                  />
                )}
              </NavLink>
            ) : (
              <img alt="Charting" src={chartIcon} />
            )}
          </Tooltip>
        </div>
        {/* <div className='navlink'>
          <Tooltip title="Charting">
            {isPatient ? (
              <NavLink
                to="/charting"
                end
                className={({ isActive }) => isActive ? 'navlink-active' : 'navlink-inactive'}
              >
                {({ isActive }) => (
                  <img
                    alt="Charting"
                    src={isActive ? toothActive : chartIcon}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMainTabNavigate(e, "/charting")}
                  />
                )}
              </NavLink>
            ) : (
              <img alt="Charting" src={chartIcon} />
            )}
          </Tooltip>
        </div> */}

        {/* Plans */}
        <div className='navlink'>
          <Tooltip title="Plans">
            {isPatient ? (
              <NavLink
                to="/plans"
                end
                className={({ isActive }) => isActive ? 'navlink-active' : 'navlink-inactive'}
              >
                {({ isActive }) => (
                  <img
                    alt="Plans"
                    src={isActive ? treatmentActive : carbon_plan}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMainTabNavigate(e, "/plans")}
                  />
                )}
              </NavLink>
            ) : (
              <img alt="Plans" src={carbon_plan} />
            )}
          </Tooltip>
        </div>

        {/* Progress Notes */}
        <div className='navlink'>
          <Tooltip title="Progress Notes">
            {isPatient ? (
              <NavLink
                to="/progress-notes"
                end
                className={({ isActive }) => isActive ? 'navlink-active' : 'navlink-inactive'}
              >
                {({ isActive }) => (
                  <img
                    alt="Progress Notes"
                    src={isActive ? notesActive : notesInActive}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMainTabNavigate(e, "/progress-notes")}
                  />
                )}
              </NavLink>
            ) : (
              <img alt="Progress Notes" src={notesInActive} />
            )}
          </Tooltip>
        </div>

        {/* Accounts */}
        <div className='navlink'>
          <Tooltip title="Account">
            {isPatient ? (
              <NavLink
                to="/accounts"
                end
                className={({ isActive }) => isActive ? 'navlink-active' : 'navlink-inactive'}
              >
                {({ isActive }) => (
                  <img
                    alt="Account"
                    src={isActive ? userActive : userSetting}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMainTabNavigate(e, "/accounts")}
                  />
                )}
              </NavLink>
            ) : (
              <img alt="Account" src={userSetting} />
            )}
          </Tooltip>
        </div>

        {/* SuperBill */}
        <div className='navlink'>
          <Tooltip title="SuperBill">
            {isPatient ? (
              <NavLink
                to="/superbill-list"
                end
                className={({ isActive }) => isActive ? 'navlink-active' : 'navlink-inactive'}
              >
                {({ isActive }) => (
                  <img
                    alt="SuperBill"
                    src={isActive ? superBillActive : superBillInActive}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMainTabNavigate(e, "/superbill-list")}
                  />
                )}
              </NavLink>
            ) : (
              <img alt="SuperBill" src={superBillInActive} />
            )}
          </Tooltip>
        </div>

      </div>

      {/* Profile Icon */}
      <div className='d-flex justify-content-center cursor'>
        <Tooltip title="Profile">
          <NavLink
            to="/clinic"
            end
          >
            <Avatar
              src={userProfileURL + user?.image}
              sx={{ width: 40, height: 40 }}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                if (isMiniWindow) {
                  e.preventDefault();
                  window.opener.location.href = "/clinic";
                }
              }}
            />
          </NavLink>

        </Tooltip>
      </div>
    </div>
  );
};

export default Sidebar;